export const DYNAMIC_ATTRIBUTES_LIST_PAGE =
  "/dynamic-attributes-editor/:entity";
